import React from 'react';
import { GiCommercialAirplane } from "react-icons/gi";

const Airline = () => {
    return (
        <>
        <div style={{height:90, width:90, borderRadius:50, backgroundColor:'white', alignText:'center'}}>
          <GiCommercialAirplane
            size={45}
            style={{marginTop: 20}}
            color='black'
          />     
        </div>
        </>
    );
};

export default Airline;

